const API_BASE_URL = 'https://rhinoapi.thevoicebusiness.com.au';

const getAuthToken = () => localStorage.getItem('token');

const apiClient = async (endpoint, { body, ...customConfig } = {}) => {
  const token = getAuthToken();
  const headers = { 'Content-Type': 'application/json' };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const config = {
    method: body ? 'POST' : 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    if (!response.ok) {
      const errorData = await response.json();
      if (response.status === 401) {
        window.localStorage.removeItem('token'); // probably expired
        window.location.href = '/login';
        return;
      }
      return Promise.reject(errorData);
    }
    return response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

// Helper for multipart/form-data upload (optionally chunked)
export const uploadMultipart = async (endpoint, formData, { method = 'POST', chunk = false } = {}) => {
  const token = getAuthToken();
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const config = {
    method,
    headers,
    body: formData,
  };
  const url = chunk ? `${API_BASE_URL}${endpoint}?chunk=true` : `${API_BASE_URL}${endpoint}`;
  try {
    const response = await fetch(url, config);
    if (!response.ok) {
      const errorData = await response.json();
      if (response.status === 401) {
        window.localStorage.removeItem('token');
        window.location.href = '/login';
        return;
      }
      return Promise.reject(errorData);
    }
    return response.json();
  } catch (error) {
    return Promise.reject(error);
  }
};

export default apiClient; 